import { render, staticRenderFns } from "./WebmastersTableOptions.vue?vue&type=template&id=132c21b2&scoped=true"
import script from "./WebmastersTableOptions.vue?vue&type=script&lang=js"
export * from "./WebmastersTableOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132c21b2",
  null
  
)

export default component.exports